import http from "@/utils/http";

// 分页查询机构老师
export function getTimetable(data) {
  return http({
    url: "/calendar/lessons?learnStatus=" + data,
    method: "GET"
  });
}

// 分页查询机构老师
export function getLessonToCourse(data) {
  return http({
    url: "/lesson/course?lessonid=" + data,
    method: "GET"
  });
}

// 开始上课
export function startClass(data) {
  return http({
    url: "/lesson/start?lessonid=" + data,
    method: "POST"
  });
}
